import Widgets from 'js-widget-hooks';
import GalleryWidget from '../modules/GalleryWidget.jsx';

Widgets.register('gallery', function(elem){
    GalleryWidget.init(elem);
});